
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("1wigE"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $1P1Tu.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $9zUhf.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $9zUhf.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("1wigE", function(module, exports) {

let $11b6f32597d7cd26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11b6f32597d7cd26$var$load("h3ABO"),
    $11b6f32597d7cd26$var$load("lTK3c"),
    $11b6f32597d7cd26$var$load("1WXdc"),
    $11b6f32597d7cd26$var$load("U4fwL"),
    $11b6f32597d7cd26$var$load("kaB35"),
    $11b6f32597d7cd26$var$load("cSvhH"),
    $11b6f32597d7cd26$var$load("6tWV0"),
    $11b6f32597d7cd26$var$load("2YffH"),
    $11b6f32597d7cd26$var$load("6wr18"),
    $11b6f32597d7cd26$var$load("6mHrv"),
    $11b6f32597d7cd26$var$load("fWKLV"),
    $11b6f32597d7cd26$var$load("2J4fZ"),
    $11b6f32597d7cd26$var$load("hdYRX"),
    $11b6f32597d7cd26$var$load("4wvcA"),
    $11b6f32597d7cd26$var$load("bjbUL"),
    $11b6f32597d7cd26$var$load("JvY8y"),
    $11b6f32597d7cd26$var$load("50ame"),
    $11b6f32597d7cd26$var$load("hZtKG"),
    $11b6f32597d7cd26$var$load("bo7iw"),
    $11b6f32597d7cd26$var$load("hyzoX"),
    $11b6f32597d7cd26$var$load("9anPW"),
    $11b6f32597d7cd26$var$load("6r6j2"),
    $11b6f32597d7cd26$var$load("c7Kmx"),
    $11b6f32597d7cd26$var$load("eBRUf"),
    $11b6f32597d7cd26$var$load("im1VN"),
    $11b6f32597d7cd26$var$load("heMxI"),
    $11b6f32597d7cd26$var$load("lR7N5"),
    $11b6f32597d7cd26$var$load("7gHIc"),
    $11b6f32597d7cd26$var$load("3yXM9"),
    $11b6f32597d7cd26$var$load("93EyF"),
    $11b6f32597d7cd26$var$load("6EuUL"),
    $11b6f32597d7cd26$var$load("Wowvf"),
    $11b6f32597d7cd26$var$load("dD2oW"),
    $11b6f32597d7cd26$var$load("5ksq8"),
    $11b6f32597d7cd26$var$load("3BYXV"),
    $11b6f32597d7cd26$var$load("c251E"),
    $11b6f32597d7cd26$var$load("fx7pC"),
    $11b6f32597d7cd26$var$load("avPjX"),
    $11b6f32597d7cd26$var$load("3GuOt"),
    $11b6f32597d7cd26$var$load("lmCjl"),
    $11b6f32597d7cd26$var$load("3sb7M"),
    $11b6f32597d7cd26$var$load("5NQgH"),
    $11b6f32597d7cd26$var$load("k3jER"),
    $11b6f32597d7cd26$var$load("9ldRJ"),
    $11b6f32597d7cd26$var$load("9wzNh"),
    $11b6f32597d7cd26$var$load("8l20h"),
    $11b6f32597d7cd26$var$load("37ldp"),
    $11b6f32597d7cd26$var$load("hhss7"),
    $11b6f32597d7cd26$var$load("6iz6l"),
    $11b6f32597d7cd26$var$load("4SCW2"),
    $11b6f32597d7cd26$var$load("ffEVr"),
    $11b6f32597d7cd26$var$load("62tEU"),
    $11b6f32597d7cd26$var$load("fJ9wN"),
    $11b6f32597d7cd26$var$load("5sTNh"),
    $11b6f32597d7cd26$var$load("jOUAD"),
    $11b6f32597d7cd26$var$load("6bVVs"),
    $11b6f32597d7cd26$var$load("7mo6o"),
    $11b6f32597d7cd26$var$load("aNMIT"),
    $11b6f32597d7cd26$var$load("k07ie"),
    $11b6f32597d7cd26$var$load("cPsVW"),
    $11b6f32597d7cd26$var$load("5GaTI"),
    $11b6f32597d7cd26$var$load("eTYdV"),
    $11b6f32597d7cd26$var$load("7EorR"),
    $11b6f32597d7cd26$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.75ed5ac7.js.map
